import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const PronunciationApiUtils = {
  fetchByStudentId(studentId) {
    return xhr(`${ApiConstants.FetchPronunciationStatuses}/${studentId}`);
  },

  updateMany(studentId, changedStatuses) {
    return xhr(ApiConstants.UpdatePronunciationStatuses, {
      method: 'put',
      body: JSON.stringify({
        student_id: studentId,
        changed_statuses: changedStatuses,
      }),
    });
  },
};

export default PronunciationApiUtils;
